import React, { useState, useEffect, useRef } from 'react';
import api from '../service/AxiosInstance';
import Axios from 'axios';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Toolbar } from 'primereact/toolbar';
import SelectSpecialite from '../components/SelectSpecialite';
import { Button } from 'primereact/button';
import { Dialog } from 'primereact/dialog';
import { GMap } from 'primereact/gmap';
import ReactExport from 'react-export-excel';
import { Circles } from 'react-loader-spinner'


const Fournisseurs = () => {

    const [listFourn, setListFourn] = useState([]);
    const [fourn, setFourn] = useState({});
    const [nbfourn, setNbFourn] = useState(0);
    const [listFournAll, setListFournAll] = useState([]);
    const dt = useRef(null);
    const [globalFilter, setGlobalFilter] = useState(null);
    const [specialite, setSpecialite] = useState('xxx');
    const [dlgFourn, setDlgFourn] = useState(false);
    const [loading, setLoading] = useState(false);

    const ExcelFile = ReactExport.ExcelFile;
    const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
    const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

    const newTab = [];


    useEffect(() => {

        setLoading(true);

        api.get("Fournisseur/list")
            .then(resp => {
                setListFourn(resp.data);
                setListFournAll(resp.data);
                setNbFourn(resp.data.length);
                setLoading(false);

            });

    }, []);

    const options = {
        center: { lat: 36.890257, lng: 30.707417 },
        zoom: 12
    };

    const editFourn = (fourn) => {

        setFourn({ ...fourn })
        setDlgFourn(true);
    }


    const onChangeSpecialite = (e) => {

        let tabList = [];

        setSpecialite(e.value);

        if (e.value === 'xxx') {
            tabList = [...listFournAll];
            setListFourn(tabList);
            setNbFourn(tabList.length);
        } else {
            tabList = [...listFournAll];
            const tabFilter = tabList.filter(f => f.codespe === e.value);
            setListFourn(tabFilter);
            setNbFourn(tabFilter.length);

        }

    }

    const onValueTableChange = (data) => {

        // if (tab.length > 0) {
        //     setListFourn(data);
        //     setNbFourn(data.length);
        // } else {
        //     setListFourn(listFournAll);
        //     setNbFourn(tab.length);
        // }
        console.log(data);
    }

    const actions = (rowData) => {
        return (
            <React.Fragment>
                {/* <i className="pi pi-fw pi-map-marker" style={{ 'fontSize': '1.5em' }}></i> */}
                <Button icon="pi pi-map-marker" className="p-button-rounded p-button-info  p-button-sm actions " aria-label="User" style={{ 'fontSize': '0.5em' }} onClick={() => editFourn(rowData)} />
            </React.Fragment>
        );
    }

    const headerEditFourn = (
        <React.Fragment>
            <span>{`${fourn.raisoc} (${fourn.intitule})`}</span><br />
            <h4 className='mt-2'>{`Adresse : ${fourn.adresse}`}</h4><br />
            <h5>{`Tel Fixe : ${fourn.telFix}`}</h5><br />
            <h5>{`Tel Mobile : ${fourn.portable}`}</h5>
        </React.Fragment>
    );

    const rightToolbarTemplate = () => {
        return (
            <React.Fragment>
                {loading &&
                    <Circles
                        height="50"
                        width="50"
                        color="#4fa94d"
                        ariaLabel="circles-loading"
                        wrapperStyle={{}}
                        wrapperClass=""
                        visible={true}
                    />
                }
                <ExcelFile filename='Fournisseurs_soins_ipm' element={<Button label="Export" icon="pi pi-upload" className="p-button-raised p-button-help p-button-text ml-3" />}>
                    <ExcelSheet data={listFourn} name="Fournisseurs">
                        <ExcelColumn label="Numero" value="numFourn" />
                        <ExcelColumn label="Raison Sociale" value="raisoc" />
                        <ExcelColumn label="Adresse" value="adresse" />
                        <ExcelColumn label="Spécialité" value="intitule" />
                        <ExcelColumn label="Tél. Portable" value="portable" />
                    </ExcelSheet>

                </ExcelFile>
            </React.Fragment>
        )
    }

    const leftToolbarTemplate = () => {
        return (
            <React.Fragment>
                <SelectSpecialite id='specialite' value={specialite} onChange={onChangeSpecialite}></SelectSpecialite>
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText className="ml-2" type="search" onInput={(e) => setGlobalFilter(e.target.value)} placeholder="Chercher..." />

                </span>
            </React.Fragment>
        )
    }


    return (
        <>
            <div className="grid">
                <div className="col-12">
                    <div className="card">
                        <h3>Liste des Fournisseurs de Soins</h3>
                        <div className="datatable-crud-demo">
                            <Toolbar className="mb-2 mt-2" left={leftToolbarTemplate} right={rightToolbarTemplate}></Toolbar>
                            <DataTable value={listFourn} ref={dt} size='small'
                                rowHover responsiveLayout='scroll'
                                globalFilter={globalFilter}
                                onChange={onValueTableChange}
                                paginator resizableColumns
                                paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
                                rows={8} rowsPerPageOptions={[8, 15, 20]}>
                                <Column field='numFourn' header='Code' sortable footer={'Total : ' + nbfourn}></Column>
                                <Column field='raisoc' header='Raison Sociale' ></Column>
                                <Column field='adresse' header='Adresse'></Column>
                                <Column field='telFix' header='Tél. Fixe'></Column>
                                <Column field='portable' header='Tél. Portable'></Column>
                                <Column field='intitule' header='Spécialité'></Column>
                                <Column body={actions} exportable={false} ></Column>
                            </DataTable>
                        </div>

                    </div>
                </div>
            </div>
            <Dialog visible={dlgFourn}
                header={headerEditFourn}
                // footer={footerEditSortiesBL}
                position='top' modal className="p-fluid"
                onHide={() => setDlgFourn(false)}
                breakpoints={{ '960px': '75vw' }} style={{ width: '60vw' }}>

                {/* <GMap options={options} style={{ width: '100%', minHeight: '320px' }} /> */}

            </Dialog>
        </>

    );
}

const comparisonFn = function (prevProps, nextProps) {
    return prevProps.location.pathname === nextProps.location.pathname;
};

export default React.memo(Fournisseurs, comparisonFn);
